export default {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    }
  },
  fr: {
    short: {
      year: "numeric",
      month: "long",
      day: "numeric"
    }
  }
};
